function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    points: "14.2,7.1 19.5,7.1 19.5,22.2  4.5,22.2 4.5,7.1 9.8,7.1  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    x1: 12,
    y1: 14.7,
    x2: 12,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2782B6",
      strokeWidth: 1.2229,
      strokeMiterlimit: 10
    },
    points: "9,4.1 12,1.1 15,4.1  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShareIcon);
export default __webpack_public_path__ + "static/media/ios-share-icon.d2a625e8c3869efe54b5e5bd32c6a6be.svg";
export { ForwardRef as ReactComponent };